import { EMPTY_STRING_ARRAY } from "../constants";
import type { DataRow } from "../types";

export function sortRows(
  rows: DataRow[],
  sortby?: string[],
  reverseSort?: string[],
) {
  const descendingKeys = sortby ?? EMPTY_STRING_ARRAY;
  const ascendingKeys = reverseSort ?? EMPTY_STRING_ARRAY;
  const descCount = descendingKeys.length;
  const ascCount = ascendingKeys.length;

  if (descCount === 0 && ascCount === 0) {
    return;
  }

  rows.sort((a, b) => {
    for (let i = 0; i < descCount; i += 1) {
      const key = descendingKeys[i];
      const av = a[key];
      const bv = b[key];
      if (av > bv) return -1;
      if (av < bv) return 1;
    }

    for (let i = 0; i < ascCount; i += 1) {
      const key = ascendingKeys[i];
      const av = a[key];
      const bv = b[key];
      if (av > bv) return 1;
      if (av < bv) return -1;
    }

    return 0;
  });
}
